import { useLocation } from 'react-router-dom'
import NavMenu from '../../components/navbar/NavMenu'
import SchoolBusNavMenu from '../../components/createForm/SchoolBusNavMenu'
import TitleBar from '../../components/navbar/TitleBar'
import RoleAssign from '../../components/role/RoleAssign'
import RoleAccess from '../role/RoleAccess'

export default function RoleAssignPage() {
    const location = useLocation()
    const isSchoolApp =
        localStorage.getItem("selectedApp") === "schoolTrack" ||
        location.pathname.startsWith("/school-users")
    const NavigationMenu = isSchoolApp ? SchoolBusNavMenu : NavMenu

    return (
        <>
            <TitleBar />
            <NavigationMenu />
            <RoleAssign />
        </>
    )
}
